import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloClient, InMemoryCache, ApolloProvider, ApolloLink } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
import { setContext } from '@apollo/client/link/context';
import { print } from 'graphql';
import App from './App';

// Minify GraphQL queries - removes unnecessary whitespace and newlines
// This makes URLs shorter and cleaner, similar to Venia's approach
function minifyQuery(query) {
  return query
    .replace(/\s+/g, ' ')  // Replace multiple whitespaces (including newlines) with single space
    .replace(/\s*([{}(),:])\s*/g, '$1')  // Remove spaces around special GraphQL characters
    .trim();
}

// Custom serializer for HttpLink that minifies queries
const customFetch = (uri, options) => {
  // If this is a GET request with a query parameter, minify it
  if (options.method === 'GET' && uri.includes('?query=')) {
    const url = new URL(uri, window.location.origin);
    const queryParam = url.searchParams.get('query');

    if (queryParam) {
      // Decode, minify, and re-encode the query
      const decoded = decodeURIComponent(queryParam);
      const minified = minifyQuery(decoded);
      url.searchParams.set('query', minified);

      // Use the minified URL
      return fetch(url.toString(), options);
    }
  }

  return fetch(uri, options);
};

// HTTP Link with GET method for queries (to support Varnish caching)
const httpLink = new HttpLink({
  uri: '/graphql',
  useGETForQueries: true,
  fetch: customFetch,
});

// Auth Link - adds authorization header if token exists
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('customerToken');

  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    }
  };
});

const client = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>
);